import { generatePath } from 'react-router-dom';

import router, { RouteItemType } from '~/core/router';
import { withSubModalsLayout } from '~/decorators/withLayout';
import lazyComponentLoader from '~/helpers/lazyComponentLoader';
import { ChatByIdPath, getChatTitle } from '~/modules/chat/constants';

const Chat = lazyComponentLoader(() => import('~/modules/chat/views'));

const WrappedChat = withSubModalsLayout(Chat);

const ChatRootRoute: RouteItemType = {
  Component: WrappedChat,
  path: '/',
  getTitle: getChatTitle,
};

const ChatByIdRoute: RouteItemType = {
  Component: WrappedChat,
  path: ChatByIdPath,
  getTitle: getChatTitle,
};

// Register as unAuthorized so both anonymous and logged-in users see the chat
router.addUnAuthorizedRoutes([ChatRootRoute, ChatByIdRoute]);

router.setDefaultPrivateRoutePath(
  generatePath(ChatByIdPath, { chatId: 'index' }),
);
